import { render, staticRenderFns } from "./CTABuySubscription.vue?vue&type=template&id=0194b02e&"
import script from "./CTABuySubscription.vue?vue&type=script&lang=js&"
export * from "./CTABuySubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports